import React, { useEffect, useState } from 'react'
import { LoaderWrapper, MuiButton, ReportHeading, ReportOuterWrapper } from '../../../../components'
import MiningTable from './miningTable'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { getObjectAsArray, exportExcel_addSegments } from '../../../../util'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import { ContentWrap, ExpandButton, RootWrap, ExpandButtonWrap, Pipe } from './style'
import { IconArrowDown, IconArrowUpBig } from '../../../../assets/images/icons'

const ReportMining = (props) => {
  const [isExpendedAll, setExpendedAll] = useState('')
  const [state, setState] = useState([])
  const [miningExcelData, setMiningExcelData] = useState([])
  const { updateSubLhsApiLoaded } = useUpdateLhs()

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: ReportsService.getInsightsMiningFramework,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  const processData = (data) => {
    const attributeData = getObjectAsArray(data?.DriverAttributes?.DriverAttributeElement)
    const arr = attributeData.map((item) => {
      const mappedData = getObjectAsArray(item.DriverSubAttributes.DriverSubAttributeElement)
      return {
        ...item,
        data: mappedData,
      }
    })
    return arr
  }

  const getMiningData = (resp) => {
    const arr = resp.map((item) => {
      return {
        ...item,
        data: processData(item),
      }
    })
    setState(arr)

    let excelData = []
    for (let a = 0; a < arr.length; a++) {
      const data1 = { value: arr[a].DriverName }
      const dataL2 = Array.isArray(arr[a]?.DriverAttributes?.DriverAttributeElement)
        ? arr[a].DriverAttributes?.DriverAttributeElement
        : arr[a]?.DriverAttributes?.DriverAttributeElement
          ? [arr[a]?.DriverAttributes?.DriverAttributeElement]
          : []
      if (dataL2?.length) {
        for (let b = 0; b < dataL2.length; b++) {
          if (dataL2[b]?.AttributeName) {
            const data2 = { value: dataL2[b].AttributeName }
            const dataL3 = dataL2[b].DriverSubAttributes
            const dataL3Array = Array.isArray(dataL3?.DriverSubAttributeElement)
              ? dataL3.DriverSubAttributeElement
              : [dataL3.DriverSubAttributeElement]
            if (dataL3Array) {
              for (let c = 0; c < dataL3Array.length; c++) {
                const data3 = { value: dataL3Array[c]?.SubAttributeName }
                // excelData.push([data1, data2, data3, {value: `${dataL3Array[c]?.PositivePercent}%`}, {value: `${dataL3Array[c]?.NeutralPercent}%`}, {value: `${dataL3Array[c]?.MixedPercent}%`}, {value: `${dataL3Array[c]?.NegativePercent}%`}, {value: `${dataL3Array[c]?.Percent}%`}])
                excelData.push([
                  data1,
                  data2,
                  data3,
                  ...exportExcel_addSegments(dataL3Array[c], true),
                ])
              }
            } else {
              // excelData.push([data1, data2, {value: '-'}, {value: `${dataL2[b].PositivePercent}%`}, {value: `${dataL2[b].NeutralPercent}%`}, {value: `${dataL2[b].MixedPercent}%`}, {value: `${dataL2[b].NegativePercent}%`}, {value: `${dataL2[b].Percent}%`}])
              excelData.push([
                data1,
                data2,
                { value: '-' },
                ...exportExcel_addSegments(dataL2[b], true),
              ])
            }
          } else {
            // excelData.push([data1, {value: dataL2[b].AttributeName}, {value: '-=3'}, {value: arr[a].PositivePercent}, {value: arr[a].NeutralPercent}, {value: arr[a].MixedPercent}, {value: arr[a].NegativePercent}, {value: arr[a].Percent}])
          }
        }
      } else {
        // excelData.push([data1, {value: '-'}, {value: '-'}, {value: arr[a].PositivePercent}, {value: arr[a].NeutralPercent}, {value: arr[a].MixedPercent}, {value: arr[a].NegativePercent}, {value: arr[a].Percent}])
      }
    }

    setTimeout(() => {
      updateSubLhsApiLoaded(props)
    }, 2000)
    setMiningExcelData(excelData)
  }

  const onSuccessFunc = (resp) => {
    getMiningData(resp)
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        additionalButton={
          <AdditionalButtons isExpendedAll={isExpendedAll} expandCollapseFunc={setExpendedAll} />
        }
        downloadId={props.type}
        downloadIdData={miningExcelData}
        {...props}
        excel={false}
      />
      <ReportOuterWrapper>
        <RootWrap
          className={`
            ${props.InsightsElementType === 'InsightsMiningFrameworkWithoutSentiments' ? 'withoutSentiment' : ''}
            ${(props?.isPPTModalActive || props?.isProgressionActive) ? 'exportToPPT' : ''}
          `}
          id={props.type}
        >
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <ContentWrap>
              <MiningTable data={state} isExpendedAll={isExpendedAll} />
            </ContentWrap>
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportMining

const AdditionalButtons = ({ isExpendedAll, expandCollapseFunc }) => {
  return (
    <>
      <MuiButton
        variant='outlined'
        color='light'
        startIcon={isExpendedAll ? <IconArrowUpBig /> : <IconArrowDown />}
        onClick={() => expandCollapseFunc(!isExpendedAll)}
      >
        {isExpendedAll ? 'Collapse All' : 'Expand All'}
      </MuiButton>
{/* 
      <ExpandButtonWrap className='BtnExpandAllMining'>
        <ExpandButton
          expended={isExpendedAll ? 'true' : ''}
          variant='standard'
          color='primary'
          onClick={() => expandCollapseFunc(true)}
        >
          <OpenInFullIcon />
          Expand All
        </ExpandButton>
      </ExpandButtonWrap>
      <Pipe className='pipe' style={{ lineHeight: 2 }}>
        |
      </Pipe>
      <ExpandButtonWrap className='BtnCollapseAllMining'>
        <ExpandButton
          expended={!isExpendedAll ? 'true' : ''}
          variant='standard'
          color='primary'
          onClick={() => expandCollapseFunc(false)}
        >
          <CloseFullscreenIcon />
          Collapse All
        </ExpandButton>
      </ExpandButtonWrap>
      <Pipe className='pipe' style={{ lineHeight: 2 }}>
        |
      </Pipe> */}
    </>
  )
}
